export default __webpack_public_path__ + "static/media/toy-robotic-arm@3x.64c3693f.png";